/**
 * `40` — *move item to {group, groupId}* · the most-used block on the account (68 automations).
 * Calls `items.moveItem`, which owns the event, the activity row and the `can()` check; already
 * being in the target group is a silent no-op with no event.
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
export const moveToGroupParams = z.object({ groupId: z.string().min(1) });
export const moveToGroupAction = defineAction({
    id: '40',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'move item to {group, groupId}',
    paramsSchema: moveToGroupParams,
    executable: true,
    references: (params) => [{ kind: 'group', id: params.groupId }],
    async execute(context, params) {
        if (context.itemId === null)
            return { skipped: 'no_item' };
        const item = await context.services.getItem(context.itemId);
        if (item === null)
            return { skipped: 'item_deleted' };
        const result = await context.services.moveItemToGroup({ itemId: context.itemId, groupId: params.groupId });
        return { itemId: context.itemId, groupId: params.groupId, changed: result.changed };
    },
});
//# sourceMappingURL=40.js.map